import {
  ChakraBox as Box,
  ChakraText as Text,
  ChakraAspectRatio as AspectRatio,
  ChakraImage as Image,
  ChakraLink as Link,
} from "@airhelp/react-ui-components";
import { ArrowIcon } from "styles/icons";
import type { SbEditableComponentProps } from "types/storyblok";
import type { PressItemProps } from "../PressItem.d";

export const PressCoverageItem = ({ href, image, title, sbEditable }: SbEditableComponentProps<PressItemProps>) => (
  <Link href={href} isExternal _hover={{ textDecor: "none" }} {...sbEditable}>
    <AspectRatio ratio={19 / 12} mb={4}>
      <Box border="1px" borderColor="greyscale.400" rounded="xl">
        <Image src={image} title={title} />
      </Box>
    </AspectRatio>
    <Text mb={2} color="primary.900" fontWeight="bold" fontSize="xl" lineHeight="1.2">
      {`${title}${ArrowIcon}`}
    </Text>
  </Link>
);
